import { supabase } from "@/services/supabase/createClient";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const getWorkspaceById = async (workspaceId: string) => {
  const { data: workspace, error } = await supabase.rpc("get_workspace", { workspace_uuid: workspaceId });

  if (error) {
    throw error;
  }

  return {
    id: workspace?.[0].workspace_id,
    name: workspace?.[0].workspace_name,
    teamId: workspace?.[0].team_id,
  };
};

export const useWorkspaceById = (workspaceId?: string) => {
  return useQuery({
    queryKey: ["workspaces", workspaceId],
    queryFn: () => getWorkspaceById(workspaceId!),
    enabled: !!workspaceId,
  });
};

export const getWorkspaces = async (teamId?: string) => {
  if (!teamId) {
    const response = await supabase.rpc("get_personal_workspaces");
    return response.data?.sort((a: any, b: any) => a.name.localeCompare(b.name));
  }

  const response = await supabase.rpc("get_team_workspaces", {
    team_uuid: teamId,
  });

  return response.data?.sort((a: any, b: any) => a.name.localeCompare(b.name));
};

export const useWorkspaces = (teamId?: string) => {
  return useQuery({
    queryKey: ["workspaces", teamId],
    queryFn: () => getWorkspaces(teamId),
  });
};

export const useWorkspaceSubscription = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["workspaces_subscription"],
    queryFn: () => {
      const channels = supabase
        .channel("workspaces_all")
        .on("postgres_changes", { event: "*", schema: "public", table: "resources" }, () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey?.[0] === "workspaces",
          });
        })
        .subscribe();
      return () => {
        channels.unsubscribe();
      };
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
